const MAPS_API_KEY = 'AIzaSyCBwYX9s_HnLnsWgD8MRHj2o6hNJCSJrGA';
const MAPS_SCRIPT_ID = 'mats-google-maps-api';
const MAPS_CALLBACK_NAME = 'matsGoogleMapsLoaded';
const MAP_ID = '38d6a35e2f5e0295b9df5a03';
const MAP_CONTAINER_ID = 'matsMap';

const SALON_POSITION = { lat: 50.811801, lng: 8.7703906 };

function loadGoogleMapsApi() {
  if (window.google?.maps?.importLibrary) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existingScript = document.getElementById(MAPS_SCRIPT_ID);

    function cleanupCallback() {
      if (window[MAPS_CALLBACK_NAME]) {
        delete window[MAPS_CALLBACK_NAME];
      }
    }

    function handleError() {
      cleanupCallback();
      reject(new Error('Google Maps API konnte nicht geladen werden.'));
    }

    if (existingScript) {
      existingScript.addEventListener(
        'load',
        () => {
          if (window.google?.maps?.importLibrary) {
            resolve();
            return;
          }

          reject(new Error('Google Maps API konnte nicht geladen werden.'));
        },
        { once: true }
      );

      existingScript.addEventListener('error', handleError, { once: true });
      return;
    }

    window[MAPS_CALLBACK_NAME] = () => {
      cleanupCallback();
      resolve();
    };

    const params = new URLSearchParams({
      key: MAPS_API_KEY,
      v: 'weekly',
      language: 'de',
      region: 'DE',
      loading: 'async',
      callback: MAPS_CALLBACK_NAME
    });

    const script = document.createElement('script');
    script.id = MAPS_SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.async = true;
    script.defer = true;
    script.addEventListener('error', handleError, { once: true });

    document.head.append(script);
  });
}

function createInfoWindow(InfoWindow) {
  return new InfoWindow({
    content:
      '<div class="map-infowindow"><strong>Mats Hair &amp; Concept</strong><br>Neustadt 27<br>35037 Marburg</div>'
  });
}

function createMarker(map, AdvancedMarkerElement, PinElement) {
  const pin = new PinElement({
    background: '#f3ede5',
    borderColor: '#2a2a27',
    glyphColor: '#2a2a27',
    scale: 1.08
  });

  const marker = new AdvancedMarkerElement({
    map,
    position: SALON_POSITION,
    title: 'Mats Hair & Concept',
    gmpClickable: true
  });

  marker.append(pin);

  return marker;
}

async function initializeMap(mapElement) {
  const [{ Map, InfoWindow }, { AdvancedMarkerElement, PinElement }] =
    await Promise.all([
      google.maps.importLibrary('maps'),
      google.maps.importLibrary('marker')
    ]);

  const map = new Map(mapElement, {
    center: SALON_POSITION,
    zoom: 17,
    mapId: MAP_ID,
    mapTypeControl: false,
    fullscreenControl: true,
    streetViewControl: true,
    zoomControl: true,
    gestureHandling: 'cooperative'
  });

  const marker = createMarker(map, AdvancedMarkerElement, PinElement);
  const infoWindow = createInfoWindow(InfoWindow);

  marker.addEventListener('gmp-click', () => {
    infoWindow.open({
      anchor: marker,
      map
    });
  });

  const tilesLoadedListener = map.addListener('tilesloaded', () => {
    mapElement.classList.remove('map-canvas--loading');
    tilesLoadedListener.remove();
  });

  window.setTimeout(() => {
    mapElement.classList.remove('map-canvas--loading');
  }, 4500);
}

async function initInteractiveMap() {
  const mapElement = document.getElementById(MAP_CONTAINER_ID);

  if (!mapElement || mapElement.dataset.mapInitialized === 'true') {
    return;
  }

  mapElement.dataset.mapInitialized = 'true';
  mapElement.classList.add('map-canvas--loading');

  try {
    await loadGoogleMapsApi();
    await initializeMap(mapElement);
  } catch (error) {
    mapElement.classList.remove('map-canvas--loading');
    mapElement.classList.add('map-canvas--error');
    mapElement.innerHTML =
      '<p>Interaktive Karte konnte nicht geladen werden. Bitte den Link "Route in Google Maps starten" verwenden.</p>';
    console.error(error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInteractiveMap, { once: true });
} else {
  initInteractiveMap();
}
